
import { IonIcon, IonFab, IonFabButton, IonLabel, IonContent, IonFooter, IonHeader, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import React from 'react';
import SQLStorage from '../SQLStorage';
import '../styles/Splash.scss';
import Logo from '../images/icon.png';
import SplashImg from '../images/splash.png';
import { addCircle } from 'ionicons/icons';
import CrossfadeImage from 'react-crossfade-image';
import Typing from 'react-typing-animation';
import TypeOut from 'react-typeout';

import China from '../images/splash/china.svg'
import India from '../images/splash/india.svg'
import Mexico from '../images/splash/mexico.svg'
import Health from '../images/splash/health.svg'
import Science from '../images/splash/science.svg'
import Development from '../images/splash/development.svg'

import Emoji1 from '../images/splash/popcorn-min.png';
import Emoji2 from '../images/splash/video-game-min.png';
import Emoji3 from '../images/splash/bubble-tea-min.png';
import Emoji4 from '../images/splash/soccer-ball-min.png';
import Emoji5 from '../images/splash/party-popper-min.png';
import Emoji6 from '../images/splash/sun-behind-small-cloud-min.png';
import Emoji7 from '../images/splash/snow-capped-mountain-min.png';
import Emoji8 from '../images/splash/dog-face-min.png';
import Emoji9 from '../images/splash/shopping-bags-min.png';
import Emoji10 from '../images/splash/bento-box-min.png';
import Emoji11 from '../images/splash/runner_emoji-modifier-fitzpatrick-type-min.png';
import Emoji12 from '../images/splash/graduation-cap-min.png';
import Emoji13 from '../images/splash/test-tube-min.png';
import Emoji14 from '../images/splash/brain-min.png';
import Emoji15 from '../images/splash/clapper-board-min.png';
import Emoji16 from '../images/splash/guitar-min.png';
import Emoji17 from '../images/splash/desert-island-min.png';
import Emoji18 from '../images/splash/briefcase-min.png';
import Emoji19 from '../images/splash/person-in-lotus-position_light-skin-tone-min.png';
import Emoji20 from '../images/splash/mosque-min.png';
import Emoji21 from '../images/splash/syringe-min.png';
import Emoji22 from '../images/splash/lungs-min.png';
import Emoji23 from '../images/splash/mechanical-arm-min.png';
import Emoji24 from '../images/splash/petri-dish-min.png';
import Emoji25 from '../images/splash/pill-min.png';
import Emoji26 from '../images/splash/rocket-min.png';
import Emoji27 from '../images/splash/dna-min.png';
import Emoji28 from '../images/splash/tongue-min.png';
import Emoji29 from '../images/splash/tooth-min.png';
import Emoji30 from '../images/splash/microscope-min.png';
import Emoji31 from '../images/splash/anatomical-heart-min.png';
import Emoji32 from '../images/splash/alembic-min.png';
import Emoji33 from '../images/splash/bone-min.png';
import Emoji34 from '../images/splash/laptop-min.png'; // JavaScript

import Emoji35 from '../images/splash/robot-min.png'; // ML
import Emoji36 from '../images/splash/cloud-min.png'; // Cloud
import Emoji37 from '../images/splash/credit-card-min.png'; // PCI
import Emoji38 from '../images/splash/locked-with-key-min.png'; // AFW
import Emoji39 from '../images/splash/abacus-min.png'; // Algorithm
import Emoji40 from '../images/splash/watch-min.png'; // Swift
import Emoji41 from '../images/splash/magnifying-glass-tilted-left-min.png'; // Auto-scaling
import Emoji42 from '../images/splash/globe-showing-asia-australia-min.png'; // Internet
import Utilities from '../Utilities';
import LanguagePickerModal from './LanguagePicker';

import { StatusBar } from '@capacitor/status-bar'

const TERMS = [
    [ // Unflipped
        [ // First row
            [ // First iteration
                ["食物", Emoji10],
                ["瑜伽", Emoji19],
                ["购物", Emoji9],
            ],
            [
                ["工作", Emoji18],
                ["山", Emoji7],
                ["太阳", Emoji6],
            ],
            [
                ["茶", Emoji3],
                ["学习", Emoji12],
                ["吉他", Emoji16],
            ]
        ],
        [
            [
                ["Atrium", Emoji31],
                ["Capsule", Emoji25],
                ["PLP", Emoji29],
            ],
            [
                ["Medullary", Emoji33],
                ["Bronchi", Emoji22],
                ["DSL", Emoji28],
            ],
            [
                ["Cerebellum", Emoji14],
                ["Vaccine", Emoji21],
                ["PTR", Emoji24],
            ]
        ],
        [
            [
                ["Palomitas", Emoji1],
                ["Fiesta", Emoji5],
                ["Perro", Emoji8],
            ],
            [
                ["Película", Emoji15],
                ["Isla", Emoji17],
                ["Guitarra", Emoji16],
            ],
            [
                ["Fútbol", Emoji4],
                ["Sol", Emoji6],
                ["Juego", Emoji2],
            ],
        ]
    ],
    [ // Flipped
        [
            [
                ["Alembic", Emoji32],
                ["Robotics", Emoji23],
                ["DNA", Emoji27],
            ],
            [
                ["Amoeba", Emoji30],
                ["Petri", Emoji24],
                ["Space", Emoji26],
            ],
            [
                ["DNA", Emoji27],
                ["Syringe", Emoji21],
                ["Sampling", Emoji13],
            ],
        ],
        [ // First iteration
            [
                ["ML", Emoji35],
                ["Algorithm", Emoji39],
                ["Cloud", Emoji36],
            ],
            [
                ["PCI", Emoji37],
                ["Swift", Emoji40],
                ["JavaScript", Emoji34],
            ],
            [
                ["AFW", Emoji38],
                ["Scaling", Emoji41],
                ["Internet", Emoji42],
            ],
        ],
        [
            [
                ["मस्जिद", Emoji20],
                ["पढ़ते पढ़ते", Emoji12],
                ["दल", Emoji5],
            ],
            [
                ["खाना", Emoji1],
                ["चलाना", Emoji11],
                ["खेल", Emoji2],
            ],
            [
                ["लैपटॉप", Emoji34],
                ["चलचित्र", Emoji15],
                ["कुत्ता", Emoji8],
            ],
        ]
    ]
]

class Splash extends React.Component {

    constructor(props) {
        super(props);
        this.transitionInterval = null;
        this.state = {
            featuresList: null,
            nextFlipI: 2,
            termsI: 0,
            flips: [false, true, false],
            justFlipped: false,
            render: [],
            languagePickerModal: null,
            selectedLang: window.settings.lang ||  "en"
        }
        StatusBar.hide();
    }

    componentDidMount() {
        this.transition();
        this.transitionInterval = setInterval(() => {
            this.transition()
        }, 1900 + 500)
    }

    transition() {
        this.setState({
            nextFlipI: this.state.nextFlipI === 1 ? 2 : this.state.nextFlipI === 2 ? 0 : 1,
            flips: [this.state.nextFlipI === 0 ? !this.state.flips[0] : this.state.flips[0], this.state.nextFlipI === 1 ? !this.state.flips[1] : this.state.flips[1], this.state.nextFlipI === 2 ? !this.state.flips[2] : this.state.flips[2]],
            termsI: this.state.termsI === 0 ? 1 : this.state.termsI === 1 ? 2 : 0,
            render: [false, false, false, false, false, false, false, false, false],
            justFlipped: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    render: [
                        this.state.render[0] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[1] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[2] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[3] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[4] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[5] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[6] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[7] || Utilities.randomIntFromInterval(0, 1),
                        this.state.render[8] || Utilities.randomIntFromInterval(0, 1),
                    ]
                })
            }, 250);
            setTimeout(() => {
                this.setState({
                    render: [true, true, true, true, true, true, true, true, true]
                })
            }, 500);
            this.setState({
                justFlipped: false,
                render: [Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1), Utilities.randomIntFromInterval(0, 1)]
            })
        })
    }

    componentWillUnmount() {
        clearInterval(this.transitionInterval);
    }

    render() {

        return (
          <IonPage data-page="splash">
              <IonHeader mode="ios">
                  <IonToolbar>
                      <IonTitle></IonTitle>
                  </IonToolbar>
              </IonHeader>
               <IonContent style={{ '--overflow': 'hidden' }}>
                   <div className="splash">
                        <div
                            className='language-picker'
                            onClick={() => {
                                this.setState({
                                    languagePickerModal: true
                                })
                            }}
                        >
                            <img src={ require('../images/flags/' + (window.globalVars.LANGUAGES_CODES_TO_COUNTRY[this.state.selectedLang].logo) + '.svg')} />
                            <span>{window.LANGUAGES[this.state.selectedLang]}</span>
                        </div>
                       <div className="showcase">
                                { this.state.flips.map((flipped, i) => {
                                    const terms = TERMS[flipped ? 1 : 0][i][this.state.termsI];
                                    return (
                                        <div 
                                            className="row"
                                            style={{
                                                justifyContent: i === 1 ? 'flex-end' : 'flex-start'
                                            }}
                                        >
                                            <div 
                                                className="subject" 
                                                data-variation={(flipped ? 1 : 0) + "-" + this.state.termsI}
                                            >
                                                <img
                                            
                                                    src={
                                                        i === 0 ? 
                                                        ( flipped ? Science : China ) :
                                                            i === 1 ?
                                                            ( flipped ? Development : Health ) :
                                                                ( flipped ? India : Mexico )
                                                    }
                                                    style={
                                                        i === 1 ? 
                                                            { marginLeft: 100 } :
                                                            { marginRight: 100 }
                                                    }
                                                />
                                                { terms.map((term, j) => {
                                                    let renderTyping = this.state.render[i*3 + j]
                                                    return (
                                                        <div className="term">
                                                            <img src={term[1]} />
                                                            { (!this.state.justFlipped && renderTyping) ?
                                                               <TypeOut infinitive={false} typeSpeed={1100/term[0].length/2} pauseSpeed={800} rewindSpeed={200/term[0].length/2} words={[term[0]]} />
                                                               : null
                                                            }
                                                        </div>
                                                    );
                                                }) }
                                            </div>
                                        </div>
                                    )
                                }) }
                        </div>
                       <div className="intro">
                            <h1>{window.ln.splashIntro}</h1>
                            <div className="options">
                                <button onClick={() => {
                                    this.props.onDismiss();
                                }}>{window.ln.getStarted}</button>
                            </div>
                       </div>
                   </div>
               </IonContent>
               <IonFooter>
                   <IonToolbar>
                       <IonTitle></IonTitle>
                   </IonToolbar>
               </IonFooter>
                <LanguagePickerModal
                    isOpen={this.state.languagePickerModal !== null}
                    selected={this.state.languagePickerModal}
                    onSelect={async (lang) => {
                        this.setState({ selectedLang: lang, languagePickerModal: null });
                        await SQLStorage.saveSetting("lang", lang);
                        // await window.dropbox.queueForUpload("setting", "lang");
                        // store.dispatch(updatedSetsSet(['null']))
                        // window.dropbox.debounce(true);
                        window.location.reload();
                    }}
                    presentingElement={this.state.pageRef ? this.state.pageRef : null}
                    onDidDismiss={() => { this.setState({ languagePickerModal: null }) }}
                />
          </IonPage>
        );
    }

};

export default withIonLifeCycle(Splash);
